import Vue from 'vue'
import axios from 'axios'

import VTooltip from 'v-tooltip'

Vue.use(VTooltip)
VTooltip.options.defaultPlacement = 'bottom'
VTooltip.options.autoHide = false

let el = document.querySelector('#office-map-view')
if(el) new Vue({
    el,
    components: {
        
    },
    data() {
        return {
            loading: true,
            showMap: true,
            markers: [],
            offices: [],
        }
    },
    methods: {
        getOffice(id) {
            let office = this.offices.filter(office => {
                return office.id == id
            })[0]
            if(!office) return

            return `
                <h4>${office.title.rendered} Office</h4>
                <p>${office.acf.address}<br />
                ${office.acf.city}, ${office.acf.state} ${office.acf.zip}</p>
                <h5>Phone Number</h5>
                <p>${office.acf.phone_number}</p>
            `
        },
        getOffices() {
            this.loading = true
            axios.get('/wp-json/wp/v2/office?per_page=100&orderby=title&order=asc').then(response => {
                console.log(response.data)
                this.offices = response.data
                this.loading = false
            })
        }
    },
    mounted() {
        this.getOffices()
        let markers = document.querySelectorAll('#office-map--map [data-office]')
        markers.forEach(marker => {
            this.markers.push({ office: Number(marker.getAttribute('data-office')), el: marker })
        })
    }
})



// WEBPACK FOOTER //
// ./assets/js/components/_office-map.js